// eslint-disable-next-line import/prefer-default-export
export const getColWidth = descriptor => (descriptor.relative === 'true' ? 48 : 72);
